import { useEffect } from "react";

const useCountryHighlight = (
  mapRef: React.RefObject<mapboxgl.Map>,
  countryBorders: GeoJSON.FeatureCollection | null
) => {
  useEffect(() => {
    if (mapRef.current && countryBorders) {
      const map = mapRef.current;

      if (map.getSource("country-highlight")) {
        const source = map.getSource("country-highlight");
        if (source) {
          (source as mapboxgl.GeoJSONSource).setData(countryBorders);
        }
      } else {
        map.addSource("country-highlight", {
          type: "geojson",
          data: countryBorders,
        });

        map.addLayer({
          id: "country-highlight-layer",
          type: "fill",
          source: "country-highlight",
          layout: {},
          paint: {
            "fill-color": "#ffa6a6", // Greenish highlight color
            "fill-opacity": 0.25, // Slight transparency
          },
        });
      }
    }
  }, [mapRef, countryBorders]);
};

export default useCountryHighlight;
